<template>
  <v-btn @click="cancel()" variant="outlined" data-cy="zeroCancelButton">
    {{ $t('buttons.cancel') }}
  </v-btn>
  <v-spacer></v-spacer>
  <v-btn @click="confirm()" class="bg-primary text-white" data-cy="zeroConfirmButton">
    {{ $t('buttons.ok') }}
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeviceZeroConfirmationActions',
  emits: ['confirm', 'cancel'],
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
})
</script>
